import { ApiCaller, Utils } from '../../config';
import { put } from 'redux-saga/effects';
import { AttendenceManagementAction } from '../actions';

export default class AttendenceManagementMiddleware {
    static *GetAttendenceMiddleware(params) {
        const { payload } = params;
        const { startDate, endDate, propertyId, scheduleId, userId, page, perPage } = payload;
        try {
            let url = '/attendance';
            let paramsArray = [];
            // paramsArray.push(`page=${page || 1}`);
            // paramsArray.push(`perPage=${perPage || 10}`);
            if (startDate) paramsArray.push(`startDate=${startDate}`);
            if (endDate) paramsArray.push(`endDate=${endDate}`);
            if (propertyId) paramsArray.push(`propertyId=${propertyId}`);
            if (scheduleId) paramsArray.push(`scheduleId=${scheduleId}`);
            if (userId) paramsArray.push(`userId=${userId}`);

            if (paramsArray.length > 0) {
                url += '?' + paramsArray.join('&');
            }

            let res = yield ApiCaller.Get(url);
            yield put(
                AttendenceManagementAction.GetAttendenceSuccess(res?.data, payload)
            );
        } catch (error) {
            yield put(AttendenceManagementAction.GetAttendenceFailure(Utils.isSubscriptionError(error)));
            Utils.showMessage('error', error?.response?.data?.message);
        }
    }

    static *GetAttendencePropertiesMiddleware(params) {
        const { payload } = params;
        try {
            let url = '/shifts/properties';
            let params = [];
            if (payload.startDate) params.push(`startDate=${payload.startDate}`);
            if (payload.endDate) params.push(`endDate=${payload.endDate}`);
            if (params.length > 0) url += '?' + params.join('&');
            let res = yield ApiCaller.Get(url);
            let propertiesOptions = res?.data?.data;
            let propertiesData = propertiesOptions.map((prop) => {
                return {
                    label: prop.name,
                    value: prop.id,
                };
            });
            yield put(
                AttendenceManagementAction.GetAttendencePropertiesSuccess(
                    propertiesData,
                ),
            );
        } catch (error) {
            yield put(
                AttendenceManagementAction.GetAttendencePropertiesFailure(),
            );
            Utils.showMessage('error', error?.response?.data?.message);
        }
    }

    static *GetAttendenceSchedulesMiddleware(params) {
        const { payload } = params;
        try {
            let res = yield ApiCaller.Get(`/all-schedules`);
            let schedulesOptions = res?.data?.data || res?.data || [];
            let scheduleData = schedulesOptions.map((prop) => {
                return {
                    label: prop.name,
                    value: prop.id,
                };
            });
            yield put(
                AttendenceManagementAction.GetAttendenceSchedulesSuccess(
                    scheduleData,
                ),
            );
        } catch (error) {
            yield put(
                AttendenceManagementAction.GetAttendenceSchedulesFailure(),
            );
            Utils.showMessage('error', error?.response?.data?.message);
        }
    }

    static *GetAttendenceUsersMiddleware(params) {
        const { payload } = params;
        const { startingDate, endingDate, property } =
            payload?.state?.filterDrawer;
        const scheduleId = Number(payload?.value);
        try {
            let url = '/users';
            let params = [];
            // if (startingDate) params.push(`startDate=${startingDate}`);
            // if (endingDate) params.push(`endDate=${endingDate}`);
            if (property) params.push(`propertyId=${property}`);
            if (scheduleId) params.push(`scheduleId=${scheduleId}`);
            if (params.length > 0) url += '?' + params.join('&');

            let res = yield ApiCaller.Get(url);
            let usersOptions = res?.data?.data;
            console.log(usersOptions);
            let usersData = usersOptions.map((prop) => {
                return {
                    label: `${prop.firstName || ''} ${prop.lastName || ''}`.trim() || prop.userName || 'Unknown User',
                    value: prop.id,
                };
            });
            yield put(
                AttendenceManagementAction.GetAttendenceUsersSuccess(usersData),
            );
        } catch (error) {
            yield put(AttendenceManagementAction.GetAttendenceUsersFailure());
            Utils.showMessage('error', error?.response?.data?.message);
        }
    }

    static *GetSidebarUsersMiddleware() {
        try {
            // /users/all returns every active user in one unpaginated array, so
            // the sidebar needs no page/perPage and the search stays on the
            // frontend (see filteredUsers in the Attendance container).
            let res = yield ApiCaller.Get('/users/all?status=active');
            let usersOptions = res?.data?.data || [];
            let usersData = usersOptions.map((u) => ({
                // firstName + lastName only — also kept as separate fields so the
                // frontend search can match on them
                label: `${u.firstName || ''} ${u.lastName || ''}`.trim() || 'Unknown User',
                value: u.id,
                firstName: u.firstName || '',
                lastName: u.lastName || '',
                profileImg: u.profileImg?.[0]?.url || null,
                hasWarning: false,
            }));
            yield put(AttendenceManagementAction.GetSidebarUsersSuccess({
                usersData: usersData,
                paginate: null,
            }));
        } catch (error) {
            yield put(AttendenceManagementAction.GetSidebarUsersFailure(Utils.isSubscriptionError(error)));
            Utils.showMessage('error', error?.response?.data?.message);
        }
    }

    // v2: load attendance by userId + dateRange only (no property/schedule filter)
    static *GetAttendenceByUserMiddleware(params) {
        const { payload } = params;
        const { userId, startDate, endDate, page, perPage } = payload;
        try {
            let url = '/attendance';
            let paramsArray = [];
            paramsArray.push(`page=${page || 1}`);
            paramsArray.push(`perPage=${perPage || 10}`);
            if (userId) paramsArray.push(`userId=${userId}`);
            if (startDate) paramsArray.push(`startDate=${startDate}`);
            if (endDate) paramsArray.push(`endDate=${endDate}`);

            if (paramsArray.length > 0) {
                url += '?' + paramsArray.join('&');
            }
            let res = yield ApiCaller.Get(url);
            yield put(AttendenceManagementAction.GetAttendenceSuccess(res?.data));
        } catch (error) {
            yield put(AttendenceManagementAction.GetAttendenceFailure(Utils.isSubscriptionError(error)));
            Utils.showMessage('error', error?.response?.data?.message);
        }
    }

    // Attendance Approval
    static *ApproveAttendanceMiddleware(params) {
        const { payload } = params;
        const { shiftUserIds } = payload;
        try {
            const res = yield ApiCaller.Patch('/attendance/approve', { shiftUserIds });
            const responseData = res?.data;
            // Show success message from backend
            const message = responseData?.message || 'Attendance approved successfully';
            Utils.showMessage('success', message);
            // Dispatch success with the updated items so the reducer can patch them in-place
            yield put(AttendenceManagementAction.ApproveAttendanceSuccess(responseData?.data || responseData));
        } catch (error) {
            const status = error?.response?.status;
            let errMsg = error?.response?.data?.message || 'Failed to approve attendance';
            if (status === 409) {
                errMsg = 'Attendance has already been approved.';
            }
            Utils.showMessage('error', errMsg);
            yield put(AttendenceManagementAction.ApproveAttendanceFailure());
        }
    }
}
